import { INTEGRATION_CHANNELS, isPlatformChannel } from 'src/data/performance';

export const AVAILABLE_INTEGRATION_CHANNELS = INTEGRATION_CHANNELS.filter(
  (channel) => !isPlatformChannel(channel)
);
